export default __webpack_public_path__ + "static/media/logo512.cb637b10.png";